export default __webpack_public_path__ + "static/media/coburgbanks-colour.46190ff7.svg";